import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  NgForm,
  Validators
} from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { EquipmentCreateService } from './equipment-create.service';
import { DialogHelper, ExceptionHelper } from './../../../../helper';

import { SiteSummaryService } from '../../site';
import { CustomerSiteSummaryService } from '../../customer';
import { ProductCategorySummaryService } from '../../product-category';
import { IsActive } from './../../../../model';
import { IOption } from 'ng-select';
import { EquipmentSummaryService } from '../equipment-summary/equipment-summary.service';


@Component({
  selector: 'app-equipment-create',
  templateUrl: './equipment-create.component.html',
  styleUrls: [
    '../../../../../scss/vendors/ng-select/ng-select.scss'
  ],
  encapsulation: ViewEncapsulation.None
})
export class EquipmentCreateComponent implements OnInit {

  @ViewChild('dangerModal') dangerModal: any;
  redirect = true;

  @Input() pageAction: string;
  @Input() customerId;
  // @Input() jobNumber;
  @Output() jobCreateStep = new EventEmitter<string>();
  @Output() jobEditStep = new EventEmitter<string>();
  @Output() jobMergeRenewStep = new EventEmitter<string>();
  @ViewChild('successModal') successModal: any;

  sites = [];
  dropdownSettingsSite = {};
  // siteOptions: Array<IOption> = [];

  productCats = [];
  dropdownSettingsProduct = {};
  forms = [];
  dropdownSettingsForm = {};
  // productCatOptions: Array<IOption> = [];

  addEquipmentForm: FormGroup;
  customerShort: FormControl;
  siteId: FormControl;
  // endUser: FormControl;
  productCategory: FormControl;
  brand: FormControl;
  model: FormControl;
  designationId: FormControl;
  productName: FormControl;
  serialNumber: FormControl;
  description: FormControl;
  type: FormControl;
  rating: FormControl;
  formIds: FormControl;
  // remarks: FormControl;

  // jobId: FormControl;
  // batteryQuantity: FormControl;
  // batteryBrandInfo: FormControl;
  // batteryBrandModel: FormControl;
  // fireServiceExpiryDate: FormControl;
  // spareParts: FormControl;
  // vendor: FormControl;
  // emergencyCall: FormControl;
  // contractStartDate: FormControl;
  // contractEndDate: FormControl;

  constructor(
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private formBuilder: FormBuilder,
    private router: Router,
    private equipmentCreateService: EquipmentCreateService,
    private equipmentSummaryService: EquipmentSummaryService,
    private siteSummaryService: SiteSummaryService,
    private customerSiteSummaryService: CustomerSiteSummaryService,
    private productCategorySummaryService: ProductCategorySummaryService,
    private translateService: TranslateService
  ) {
    translateService.setDefaultLang('en-us');
  }

  ngOnInit() {
    this.dropdownSettingsSite = {
      singleSelection: true,
      text: 'Select Site',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'locationShort'
    };
    this.dropdownSettingsProduct = {
      singleSelection: true,
      text: 'Select Product Category',
      enableSearchFilter: true,
      enableFilterSelectAll: false,
      labelKey: 'name'
    };

    this.dropdownSettingsForm = {
      singleSelection: false,
      text: 'Select Form',
      enableSearchFilter: true,
      labelKey: 'name'
    };

    this.createEquipmentFormControls();
    // this.createJobSpecficControls();

    // this.createForm();
    this.getSiteSummary();
    this.getProductCategorySummary();
  }

  // validations not confirmed yet
  public createEquipmentFormControls(): void {
    // this.customerShort = new FormControl('', [
    //   Validators.required
    // ]),
    this.siteId = new FormControl('', [
      Validators.required
    ]),
    // this.endUser = new FormControl('', [
    //   Validators.required,
    // ]),
    this.productCategory = new FormControl('', [
      Validators.required
    ]),
    this.brand = new FormControl('', [
      Validators.required,
      Validators.maxLength(100)
    ]),
    this.model = new FormControl('', [
      Validators.required,
      Validators.maxLength(100)
    ]),
    this.designationId = new FormControl('', [
      Validators.required,
      Validators.maxLength(100)
    ]),
    this.productName = new FormControl('', [
      // Validators.required,
      Validators.maxLength(100)
    ]),
    this.serialNumber = new FormControl('', [
      Validators.maxLength(100)
    ]);
    this.description = new FormControl('', [
      // Validators.required,
      Validators.maxLength(100)
    ]),
    this.type = new FormControl('', [
      // Validators.required,
      Validators.maxLength(100)
    ]),
    this.rating = new FormControl('', [
      // Validators.required,
      Validators.maxLength(100)
    // ]),
    // this.remarks = new FormControl('', [
    //   // Validators.required,
    //   Validators.maxLength(1000)
    ]);
    this.formIds = new FormControl([]),
    // this.createJobSpecficControls();
    this.getForms();
    this.createForm();
  }

  // validations not confirmed yet
  // public createJobSpecficControls(): void {
  //   // this.jobId = new FormControl({value: this.jobNumber, disabled: true }, [
  //   this.jobId = new FormControl('', [
  //     Validators.required,
  //     Validators.maxLength(100)
  //   ]),
  //   this.batteryQuantity = new FormControl('', [
  //     // Validators.required
  //     Validators.maxLength(100)
  //   ]),
  //   this.batteryBrandInfo = new FormControl('', [
  //     // Validators.required
  //     Validators.maxLength(100)
  //   ]),
  //   this.batteryBrandModel = new FormControl('', [
  //     // Validators.required
  //     Validators.maxLength(100)
  //   ]),
  //   this.fireServiceExpiryDate = new FormControl('', [
  //     // Validators.required
  //     Validators.maxLength(100)
  //   ]),
  //   this.spareParts = new FormControl('', [
  //     // Validators.required
  //     Validators.maxLength(100)
  //   ]),
  //   this.vendor = new FormControl('', [
  //     // Validators.required
  //     Validators.maxLength(100)
  //   ]),
  //   this.emergencyCall = new FormControl('', [
  //     // Validators.required
  //     Validators.maxLength(100)
  //   ]),
  //   this.contractStartDate = new FormControl('', [
  //     Validators.required,
  //     Validators.maxLength(100)
  //   ]),
  //   this.contractEndDate = new FormControl('', [
  //     Validators.required,
  //     Validators.maxLength(100)
  //   ]);

  //   this.createForm();
  // }

  public createForm(): void {
    this.addEquipmentForm = this.formBuilder.group({
      customer: this.customerShort,
      siteId: this.siteId,
      // endUser: this.endUser,
      productCategory: this.productCategory,
      brand: this.brand,
      model: this.model,
      designationId: this.designationId,
      productName: this.productName,
      serialNumber: this.serialNumber,
      description: this.description,
      type: this.type,
      rating: this.rating,
      formIds: this.formIds
      // remarks: this.remarks,
      // jobId: this.jobId,
      // batteryQuantity: this.batteryQuantity,
      // batteryBrandInfo: this.batteryBrandInfo,
      // batteryBrandModel: this.batteryBrandModel,
      // fireServiceExpiryDate: this.fireServiceExpiryDate,
      // spareParts: this.spareParts,
      // vendor: this.vendor,
      // emergencyCall: this.emergencyCall,
      // contractStartDate: this.contractStartDate,
      // contractEndDate: this.contractEndDate
    });
  }

  public getProductCategorySummary(): void {
    this.productCategorySummaryService.getSummary(IsActive.active)
      .subscribe((data: any) => {
        this.productCats = data.productCatListModel;
        // const options = [];
        // for (const productCat of this.productCats) {
        //   let option: any;
        //   option = { label: productCat.name, value: productCat.id };
        //   options.push(option);
        // }

        // this.productCatOptions = options;
        $('div.c-btn').attr('id', 'single-select');
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  public getForms(): void {
     this.equipmentSummaryService.getForms().subscribe(res => {
       this.forms = res.formListModel;
     });
  }
  public getSiteSummary(): void {
    // this.siteSummaryService.getSummary(IsActive.active)
    this.customerSiteSummaryService.getSummary(this.customerId, IsActive.active)
      .subscribe((data: any) => {
        this.sites = data.siteListModel;
        // const options = [];
        // for (const site of this.sites) {
        //   let option: any;
        //   option = { label: site.locationShort, value: site.id };
        //   options.push(option);
        // }
        // this.siteOptions = options;
        $('div.c-btn').attr('id', 'single-select');
      },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
        this.redirect = true;
      });
  }

  public addEquipment(addEquipmentForm): void  {
    this.equipmentCreateService.create(addEquipmentForm.controls)
      .subscribe(
        data => {
          if (data) {
            this.dialog.showModal('showSucModalBtn');
          }
        },
        err => {
          this.exception.showError(err, 'showDanModalBtn');
          this.redirect = false;
        }
      );
  }

  closeSuccessModel() {
    // this.router.navigate(['/home/equipment']);
    this.goBack();
  }

  errorClose() {
    if (this.redirect) {
      this.goBack();
    }
    else {
      this.dangerModal.hide();
    }

  }

  // continue() {
  //   this.successModal.hide();
  //   this.router.navigate([this.router.url]);
  //   this.ngOnInit();
  // }

  public goBack(): void {
    this.jobCreateStep.emit('addEquipment');
    this.jobEditStep.emit('addEquipment');
    this.jobMergeRenewStep.emit('addEquipment');
  }

  public onCloseSite(items: any) {
    if (this.addEquipmentForm.value.siteId.length === 0) {
      this.addEquipmentForm.controls['siteId'].setErrors({'required': true});
    }
  }

  public onCloseProduct(items: any) {
    if (this.addEquipmentForm.value.productCategory.length === 0) {
      this.addEquipmentForm.controls['productCategory'].setErrors({'required': true});
    }
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/equipment/equipment-create/equipment-create.component.ts